import type IPrivacyPolicyRepository from '../IPrivacyPolicyRepository';
import type { PrivacyPolicyPublicDTO, PrivacyPolicySimpleDTO } from '../privacyPolicy.types';
import { injectable } from 'inversify';
import qs from 'qs';
import API from '@repositories/Axios';

@injectable()
export class PrivacyPolicyRepository implements IPrivacyPolicyRepository {
  async getPrivacyPolicyList(): Promise<PrivacyPolicySimpleDTO[]> {
    const response = await API.get<PrivacyPolicySimpleDTO[]>('/api/v1/privacy-policies');
    return response.data;
  }
  async getPrivacyPolicy(version: number, lang: string): Promise<PrivacyPolicyPublicDTO> {
    const queryString = qs.stringify({ version, lang });
    const response = await API.get<PrivacyPolicyPublicDTO>(`/api/v1/privacy-policies/${version}?${queryString}`);
    return response.data;
  }
}
